import { render, staticRenderFns } from "./OptimizerCheckbox.vue?vue&type=template&id=0db559b2&scoped=true&"
import script from "./OptimizerCheckbox.vue?vue&type=script&lang=js&"
export * from "./OptimizerCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db559b2",
  null
  
)

export default component.exports